// extracted by mini-css-extract-plugin
export default {"privacyLink":"ConnectorsDescription_privacyLink__gXI71"};